/* eslint-disable react/no-adjacent-inline-elements */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-restricted-syntax */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-inner-declarations */
/* eslint-disable react/prop-types */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { useEffect } from 'react';
import {
  Grid,
  Card,
  CardHeader,
  CardBody,
  Section,
  Alert,
  Column,
} from '@govhhs/govhhs-design-system-react';
import { Link as RouterLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import PATHS from '@spm/universal-access-ui/src/router/Paths';
import featureToggles from '@spm/universal-access-ui/src/features/featureToggles';
import PropTypes from 'prop-types';
import Spinner from '@govhhs/govhhs-design-system-react/lib/components/Spinner';
import messages from './OrganisationComponentMessages';
import { ID } from '../constants';

/**
 * The OrganisationComponent component handles the rendering of the Organisation
 * feature.
 *
 * @namespace OrganisationComponent
 * @memberof features.Organisation/components
 */
const OrganisationComponent = props => {
  const { intl, isFundAvailableInd, userStatusInd, isFundRetrievingInd } = props;

  // console.log("funds: " + JSON.stringify(isFundAvailableInd))
  // console.log("isFundRetrievingInd = " + JSON.stringify(isFundRetrievingInd));
  const isFundRetrieving = isFundRetrievingInd;
  let isFundAvailable = true;
  if (isFundAvailableInd) {
    isFundAvailable = isFundAvailableInd.isFundAvailable;
    let isChapFundAvailable = '';
    let isFIChapFundAvailable = '';
    let isFiChapAlreadyApplied = '';
    let isECHAPFundAvailable = '';
    let isECHAPAlreadyApplied = '';
    let isWSAPFundAvailable = '';

    if (userStatusInd) {
      isChapFundAvailable = userStatusInd.isChapFundAvailable;
      isFIChapFundAvailable = userStatusInd.isFIChapFundAvailabe;
      isFiChapAlreadyApplied = userStatusInd.isFiChapAlreadyApplied;
      isECHAPFundAvailable = userStatusInd.isECHAPFundAvailable;
      isECHAPAlreadyApplied = userStatusInd.isECHAPAlreadyApplied;
      isWSAPFundAvailable = userStatusInd.isWSAPFundAvailable;
    }

    function NoFIFunds() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  {intl.formatMessage(messages.organisationFIMessage)} <br />
                  {intl.formatMessage(messages.organisationFIMessage1)} <br />
                  {intl.formatMessage(messages.organisationFIMessage2)} <br />
                  {intl.formatMessage(messages.organisationFIMessage3)} <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function NoCHAPFunds() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  {intl.formatMessage(messages.organisationCHAPMessage)} <br />
                  {intl.formatMessage(messages.organisationCHAPMessage1)} <br />
                  {intl.formatMessage(messages.organisationCHAPMessage2)} <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function NoFIFundsOrCHAPFunds() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  {intl.formatMessage(messages.organisationFIMessage)} <br />
                  {intl.formatMessage(messages.organisationFIMessage1)} <br />
                  {intl.formatMessage(messages.organisationFIMessage2)} <br />
                  {intl.formatMessage(messages.organisationNoCHAPNoFIFundsMessage)} <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function NoFIFundsOrCHAPFundsAlreadyApplied() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  {intl.formatMessage(messages.organisationCHAPMessage)} <br />
                  {intl.formatMessage(messages.organisationFIMessage1)} <br />
                  {intl.formatMessage(messages.organisationCHAPMessage1)} <br />
                  {intl.formatMessage(messages.organisationNoCHAPNoFIFundsMessage)} <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function CHPAWaitlistAlertMessage() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b>
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage5)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage6)}
                  <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function CHAPNo_FICHAPYes_ECHAPYes() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b>
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage5)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage6)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFICHAPProgramDescription)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationApplyForFIorECHAP)}
                  <br />

                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function CHAPNo_FICHAPNo_ECHAPYes() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b>
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage5)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage6)}
                  <br />
                  <b>{intl.formatMessage(messages.organisationFIAvailabilityTitle)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage1)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationApplyForECHAP)}
                  <br />

                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function FICHAPNo_ECHAPYes() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  
                  {/* {intl.formatMessage(messages.organisationCHAPProgramDescription)}<br /><br/> */}
                  <b>{intl.formatMessage(messages.organisationFIAvailabilityTitle)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage1)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}<br/>
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}<br/>
                  {intl.formatMessage(messages.fixedIncomeRequirementTitle)}<br/>
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}<br/>
                  {intl.formatMessage(messages.evictionCHAPRequirementTitle)}<br/> 
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage7)}<br/>
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function FICHAPYes_ECHAPNo() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >

                  {/* {intl.formatMessage(messages.organisationCHAPProgramDescription)}<br /><br/> */}
                  <b>{intl.formatMessage(messages.organisationECHAPTitleMessage)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage2)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.fixedIncomeRequirementTitle)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.evictionCHAPRequirementTitle)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage7)}
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function FICHAPNo_ECHAPNo() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert className="wds-u-mb--base" dismissable={false} iconSize="medium" type="danger">
                {/* Bug 2602 FI/EP Out of Funds d1d */}
                {/* <b> {intl.formatMessage(messages.importantMessageFI)} </b> <br/>
                {intl.formatMessage(messages.organisationFIMessage)} <br/>
                {intl.formatMessage(messages.organisationFIMessage1)} <br/><br/> 
                <b> {intl.formatMessage(messages.organisationECHAPTitleMessage)} </b> <br/>
                {intl.formatMessage(messages.organisationECHAPMessage1)} <br/>
                {intl.formatMessage(messages.organisationECHAPMessage2)} <br/><br/>  */}
                 
                  {/* {intl.formatMessage(messages.organisationFundAvailabilityMessage)} <br/><br/> */}
                  {intl.formatMessage(messages.otherProgramsTitleMessage)} <br/> <br/>
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)} <br />
                  {intl.formatMessage(messages.fixedIncomeRequirementTitle)} <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)} <br /> <br /> <br />
                 
                  {/* {intl.formatMessage(messages.evictionCHAPRequirementTitle)} <br /> <br />  */}
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage7)} <br />
                  {/* {intl.formatMessage(messages.organisationCHAPProgramDescription)}<br /><br/> */}
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function FICHAPYes_ECHAPYes() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b><br />
                {intl.formatMessage(messages.organisationFundAvailabilityMessage)}<br /><br/>
                {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}<br />
                {intl.formatMessage(messages.fixedIncomeRequirementTitle)}<br />
                {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}<br />
                {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}<br />
                {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}<br />
                 {intl.formatMessage(messages.evictionCHAPRequirementTitle)}<br /><br /> 
                {intl.formatMessage(messages.organisationFundAvailabilityMessage7)}<br />
                {/* {intl.formatMessage(messages.organisationCHAPProgramDescription)}<br /><br/> */}
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function CHAPNo_FICHAPYes_ECHAPNo() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage5)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage6)}
                  <br />
                  <br />
                  <b>{intl.formatMessage(messages.organisationECHAPTitleMessage)}</b>
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage2)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationFICHAPProgramDescription)}
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationApplyForFICHAP)}
                  <br />
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function NoFundsAvailable() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationFundAvailabilityTitle)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage2)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage3)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage4)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage5)}
                  <br />
                  {intl.formatMessage(messages.organisationFundAvailabilityMessage6)}
                  <br />
                  <br />
                  <b>{intl.formatMessage(messages.organisationFIAvailabilityTitle)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage)}
                  <br />
                  {intl.formatMessage(messages.organisationFIMessage1)}
                  <br />
                  <br />
                  <b>{intl.formatMessage(messages.organisationECHAPTitleMessage)}</b>
                  <br />
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage1)}
                  <br />
                  {intl.formatMessage(messages.organisationECHAPMessage2)}
                  <br />
                  <br />

                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function AppllyBenfitCard() {
      return [
        <>
          <Card
            callout
            data-testid={ID.VIEW_YOUR_BENEFITS_CARD_ID}
            link={<RouterLink to={PATHS.APPLY} />}
          >
            <CardHeader title={intl.formatMessage(messages.organisationApplyForBenefits)} />
            <CardBody>
              <p>{intl.formatMessage(messages.organisationStartYourApplication)}</p>
            </CardBody>
          </Card>
        </>,
      ];
    }

    function EnrollWaitlistCard() {
      return [
        <>
          <Card callout data-testid={ID.ENROLL_WAITLIST} link={<RouterLink to={PATHS.APPLY} />}>
            <CardBody>
              <p>
                <b>{intl.formatMessage(messages.organisationEnrollInWaitList)}</b>
              </p>
            </CardBody>
          </Card>
        </>,
      ];
    }

    function FIAlertMessage() {
      if (
        isFIChapFundAvailable === false &&
        isChapFundAvailable === true &&
        isFiChapAlreadyApplied === false
      ) {
        console.log('No FI CHAP funds');
        return <NoFIFunds />;
      }
      if (isFIChapFundAvailable === false && isChapFundAvailable === true) {
        if (isFiChapAlreadyApplied === true) {
          console.log('No FI CHAP funds and user has already applied');
        }
        console.log('No FI CHAP funds');
        return <NoFIFunds />;
      }
      /* else if (isChapFundAvailable == false && isFIChapFundAvailable == true) {
        console.log('No CHAP funds')
        return <NoCHAPFunds />
      } */ if (isChapFundAvailable === false && isFIChapFundAvailable === false) {
        if (isFiChapAlreadyApplied === true) {
          console.log('No CHAP or FI CHAP funds and returning user');
          return <NoFIFundsOrCHAPFundsAlreadyApplied />;
        }
        if (isFundRetrieving === true) {
          console.log('CHAP funds are retrieving');
          return <Spinner />;
        }
        console.log('No CHAP or FI CHAP funds');
        return <NoFIFundsOrCHAPFunds />;
      }
      return null;
    }

    function NoMoreCHAPAlert() {
      return [
        <>
          <>
            <Grid>
              <Column>
                <Alert
                  className="wds-u-mb--base"
                  dismissable={false}
                  iconSize="medium"
                  type="danger"
                >
                  <b>{intl.formatMessage(messages.organisationNoMoreCHAPMessageHead)}</b>
                  <br />
                  {intl.formatMessage(messages.organisationNoMoreCHAPMessage)}
                  <br />
                </Alert>
              </Column>
            </Grid>
          </>
        </>,
      ];
    }

    function DisplayWSAPFundAvailable() {
       return (
        <Grid>
          <Column>
            <Alert className="wds-u-mb--base" dismissable={false} iconSize="medium" type="danger">
             
              {intl.formatMessage(messages.wsapFundAvailableMessage)}
              <br />
             
            </Alert>
          </Column>
        </Grid>
      )
    }

    function DisplayWSAPFundNotAvailable(){
     return (
        <Grid>
          <Column>
            <Alert className="wds-u-mb--base" dismissable={false} iconSize="medium" type="danger">
             
              {intl.formatMessage(messages.wsapFundNotAvailableMessage)}
              <br />
             
            </Alert>
          </Column>
        </Grid>
      ) 
    
    }


    function DisplayNoCHAPApplicationsMessage() {
      return <NoMoreCHAPAlert />;
    }

    function DisplayAlertMessage() {
      if (isFIChapFundAvailable === false && isECHAPFundAvailable === true) {
        return <FICHAPNo_ECHAPYes />;
      }
      if (isFIChapFundAvailable === true && isECHAPFundAvailable === false) {
        return <FICHAPYes_ECHAPNo />;
      }
      if (isFIChapFundAvailable === false && isECHAPFundAvailable === false) {
        return <FICHAPNo_ECHAPNo />;
      }
      if (isFIChapFundAvailable === true && isECHAPFundAvailable === true) {
        return <FICHAPYes_ECHAPYes />;
      }
      return null;
    }

    function CHAPWaitlistAlertMessage() {
      if (!isFundAvailable) {
        console.log('No CHAP funds');
        return <CHPAWaitlistAlertMessage />;
      }
      return null;
    }

    function AppllyBenfitGridCard() {
     
        return <AppllyBenfitCard />;
     
    }

    function EnrollWaitlistGridCard() {
      if (!isFundAvailable) {
        return <EnrollWaitlistCard />;
      }
      return null;
    }

    return (
      <>
        <Section
          aria-label={intl.formatMessage(messages.organisationAriaSection)}
          data-testid={ID.HOME_PAGE_SECTION_ID}
        >
          {/* <DisplayNoCHAPApplicationsMessage/> */}
          <DisplayAlertMessage />
         {isWSAPFundAvailable && <DisplayWSAPFundAvailable/>}
           {!isWSAPFundAvailable } 
          {/* <CHAPWaitlistAlertMessage /> */}
          {
            <>
              <Grid auto>
                {<AppllyBenfitGridCard />}
                {/* <EnrollWaitlistGridCard />  */}
                <Card
                  callout
                  data-testid={ID.VIEW_YOUR_ACCOUNT_CARD_ID}
                  link={<RouterLink to={PATHS.ACCOUNT} />}
                >
                  <CardHeader title={intl.formatMessage(messages.organisationViewYourAccount)} />
                  <CardBody>
                    <p>
                      {intl.formatMessage(
                        featureToggles.lifeEvents.isEnabled()
                          ? messages.organisationSeeYourNextPayment_LifeEventsEnabled
                          : messages.organisationSeeYourNextPayment
                      )}
                    </p>
                  </CardBody>
                </Card>
              </Grid>
              <br />
            </>
          }
        </Section>
      </>
    );
  }
  return <></>;
};

/**
 * The OrganisationComponent properties.
 *
 * See https://reactjs.org/docs/react-component.html#props
 *
 * @memberof OrganisationComponent
 */
OrganisationComponent.propTypes = {
  intl: PropTypes.object.isRequired,
  isFundAvailableInd: PropTypes.bool.isRequired,
};

export default injectIntl(OrganisationComponent);
